import { BLOCK_TYPES } from "./blocks";

export const FIELD_TYPES = {
  RICH_TEXT: "rich_text",
  STRING: "string",
  NUMBER: "number",
  IMAGE: "image",
  VIDEO: "video",
  AUDIO: "audio",
  COLLECTION: "collection",
  WORKOUT: "workout",
  FORM: "form",
  ATTACHMENT: "attachment",
  ICON_LIST: "icon_list",
  ADDRESS: "address",
  ARRAY: "array",
} as const;

export type SlotFieldType =
  typeof FIELD_TYPES[keyof typeof FIELD_TYPES];

export type SlotFieldDefinition = {
  key: string;
  label: string;
  type: SlotFieldType;
};

// Only block types that support per-page data overrides via shared streams.
// Additional block types (button, workout, collection, attachment, icon_list,
// image, map, form) will be added in a follow-up PR once their read/write
// plumbing is fully wired.
export const BLOCK_SLOT_FIELDS: Record<string, SlotFieldDefinition[]> = {
  [BLOCK_TYPES.TEXT_BLOCK]: [
    { key: "content", label: "Text", type: FIELD_TYPES.RICH_TEXT },
  ],
  [BLOCK_TYPES.HERO_BLOCK]: [
    { key: "image", label: "Image", type: FIELD_TYPES.IMAGE },
    { key: "video", label: "Video", type: FIELD_TYPES.VIDEO },
    { key: "audio", label: "Audio", type: FIELD_TYPES.AUDIO },
  ],
  [BLOCK_TYPES.IFRAME_BLOCK]: [
    { key: "url", label: "URL", type: FIELD_TYPES.STRING },
  ],
};

export const getSlotFields = (
  blockType: string
): SlotFieldDefinition[] => {
  return BLOCK_SLOT_FIELDS[blockType] || [];
};

export const isSlotField = (
  blockType: string,
  fieldKey: string
): boolean => {
  const slots = BLOCK_SLOT_FIELDS[blockType];

  if (!slots) return false;

  return slots.some((slot) => slot.key === fieldKey);
};

const SLOT_FIELD_SLUG_PREFIX = "blocks.";

export const slotFieldSlug = (
  blockUuid: string,
  fieldKey: string
): string => `${SLOT_FIELD_SLUG_PREFIX}${blockUuid}.${fieldKey}`;

export const parseSlotFieldSlug = (
  slotSlug: string | null | undefined
): { blockUuid: string; fieldKey: string } | null => {
  if (!slotSlug?.startsWith(SLOT_FIELD_SLUG_PREFIX)) return null;

  const parts = slotSlug.split(".");

  if (parts.length < 3) return null;

  return {
    blockUuid: parts[1],
    fieldKey: parts.slice(2).join("."),
  };
};
